import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaCalculator, FaChartLine, FaBuilding, FaTimes, FaBars } from "react-icons/fa";
import logo from "../Assets/Images/BooksCompl.png";
import ContactForm from "../ContactForm/ContactFormModal.js";

const NavigationBar = () => {
  const [showDropdownServices, setShowDropdownServices] = useState(false);
  const [showContactForm, setShowContactForm] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const servicesItems = [
    { label: "USA Company Formation", icon: FaCalculator, path: "/usa-company-formation" },
    { label: "Tax Return", icon: FaBuilding, path: "/tax-return" },
    { label: "Bookkeeping", icon: FaCalculator, path: "/bookkeeping" },
    { label: "CFO Advisory", icon: FaChartLine, path: "/cfo-advisory" },
    { label: "Zoho Advisory", icon: FaChartLine, path: "/zoho-advisory" },
  ];

  const handleGetStartedClick = (e) => {
    e.preventDefault();
    setShowContactForm(true);
  };

  const handleCloseContactForm = () => {
    setShowContactForm(false);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <>
      <nav 
        className="sticky top-0 z-[1020] bg-white shadow-sm py-2" 
        aria-label="Main Navigation"
        role="navigation"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            <p className="sr-only" role="heading" aria-level="2">
              BooksComply - Main Navigation
            </p>
            <Link 
              className="flex-shrink-0" 
              to="/" 
              onClick={closeMobileMenu}
              aria-label="BooksComply Home"
            >
              <img 
                src={logo} 
                alt="BooksComply Logo" 
                className="hidden md:block w-[250px] h-auto"
                width="250"
                height="auto"
                loading="lazy"
              />
              <img 
                src={logo} 
                alt="BooksComply Logo" 
                className="md:hidden w-[200px] h-auto"
                width="200"
                height="auto"
                loading="lazy"
              />
            </Link>

            {/* Mobile menu button */}
            <button
              className="lg:hidden ml-auto p-2 border-0 bg-transparent"
              type="button"
              onClick={toggleMobileMenu}
              aria-expanded={mobileMenuOpen}
              aria-label="Toggle navigation"
            >
              {mobileMenuOpen ? (
                <FaTimes className="text-[#131738] text-2xl" />
              ) : (
                <FaBars className="text-[#131738] text-2xl" />
              )}
            </button>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex lg:items-center lg:ml-auto">
              <ul className="flex items-center gap-8 mb-0" role="menubar" aria-label="Main Menu">
                <li role="none">
                  <Link 
                    className="text-[17px] font-medium text-[#101536] hover:text-[#1d4ed8] transition-colors duration-200 no-underline" 
                    to="/" 
                    role="menuitem"
                    aria-current={window.location.pathname === '/' ? 'page' : undefined}
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  >
                    Home
                  </Link>
                </li>
                
                <li 
                  className="relative" 
                  role="none"
                  onMouseEnter={() => setShowDropdownServices(true)}
                  onMouseLeave={() => setShowDropdownServices(false)}
                >
                  <Link
                    className="flex items-center gap-1 text-[17px] font-medium text-[#101536] hover:text-[#1d4ed8] transition-colors duration-200 no-underline"
                    to="#"
                    id="servicesDropdown"
                    role="menuitem"
                    aria-haspopup="true"
                    aria-expanded={showDropdownServices}
                    onClick={(e) => {
                      e.preventDefault();
                      setShowDropdownServices(!showDropdownServices);
                    }}
                  >
                    Services
                    <svg className={`w-4 h-4 transition-transform duration-200 ${showDropdownServices ? "rotate-180" : ""}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </Link>
                  <ul
                    id="services-menu"
                    className={`absolute left-1/2 -translate-x-1/2 top-full mt-3 min-w-[280px] max-w-[90vw] rounded-[26px] border border-[#e2e8f0] bg-white shadow-[0_22px_40px_rgba(15,23,42,0.18)] px-4 py-4 transition-all duration-200 ${showDropdownServices ? "opacity-100 visible translate-y-0" : "opacity-0 invisible -translate-y-3"}`}
                    role="menu"
                    aria-labelledby="servicesDropdown"
                  >
                    {servicesItems.map((item, index) => (
                      <li key={index} role="none">
                        <Link 
                          className="flex items-center gap-3 rounded-2xl px-3 py-2.5 text-[#131738] text-[15px] transition-all duration-200 no-underline hover:bg-[#eff6ff]"
                          to={item.path} 
                          role="menuitem"
                          onClick={() => setShowDropdownServices(false)}
                        >
                          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#edf4ff] text-[#2563eb]">
                            <item.icon aria-hidden="true" />
                          </span>
                          <span className="font-medium leading-snug whitespace-nowrap">{item.label}</span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
                
                <li role="none">
                  <Link 
                    className="text-[17px] font-medium text-[#101536] hover:text-[#1d4ed8] transition-colors duration-200 no-underline" 
                    to="/pricing" 
                    role="menuitem"
                    aria-current={window.location.pathname === '/pricing' ? 'page' : undefined}
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  >
                    Pricing
                  </Link>
                </li>
                
                <li role="none">
                  <Link 
                    className="text-[17px] font-medium text-[#101536] hover:text-[#1d4ed8] transition-colors duration-200 no-underline" 
                    to="/why-bookscomply" 
                    role="menuitem"
                    aria-current={window.location.pathname === '/why-bookscomply' ? 'page' : undefined}
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  >
                    Why BooksComply
                  </Link>
                </li>
                
                <li role="none">
                  <Link 
                    className="text-[17px] font-medium text-[#101536] hover:text-[#1d4ed8] transition-colors duration-200 no-underline" 
                    to="/blog" 
                    role="menuitem"
                    aria-current={window.location.pathname.startsWith('/blog') ? 'page' : undefined}
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  >
                    Blog
                  </Link>
                </li>
              </ul>

              <div className="flex items-center ml-6" role="navigation" aria-label="Account Actions">
                <button
                  className="bg-[#ffc107] text-black font-bold px-4 py-2 rounded-md mr-2 hover:bg-white hover:text-[#ffc107] hover:border hover:border-[#ffc107] transition-all duration-300"
                  onClick={handleGetStartedClick}
                  aria-label="Contact Us"
                >
                  Get in Touch
                </button>
                <button
                  className="bg-[#007bff] text-white font-bold px-4 py-2 rounded-md ml-2 hover:bg-[#0056b3] transition-all duration-300"
                  onClick={() => {
                    window.location.href = `${process.env.REACT_APP_REDIRECT_URL}/login`;
                  }}
                  aria-label="Login to your account"
                >
                  Login
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Navigation Overlay */}
        {mobileMenuOpen && (
          <div 
            className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[1040] lg:hidden"
            onClick={closeMobileMenu}
          />
        )}

        {/* Mobile Navigation Menu */}
        <div 
          className={`fixed top-0 right-0 w-[300px] h-screen bg-gradient-to-b from-white to-[#f8fafc] shadow-[-8px_0_30px_rgba(0,0,0,0.15)] z-[1050] transform transition-transform duration-300 ease-out lg:hidden overflow-y-auto ${mobileMenuOpen ? "translate-x-0" : "translate-x-full"}`}
          role="navigation"
          aria-label="Mobile Menu"
        >
          {/* Header with Logo and Close */}
          <div className="flex items-center justify-between px-5 py-4 border-b border-[#e2e8f0]">
            <img src={logo} alt="BooksComply" className="h-10 w-auto" />
            <button
              className="flex items-center justify-center w-10 h-10 rounded-full bg-[#f1f5f9] text-[#131738] hover:bg-[#e2e8f0] transition-colors duration-200"
              onClick={closeMobileMenu}
              aria-label="Close main menu"
            >
              <FaTimes aria-hidden="true" />
            </button>
          </div>

          <ul className="flex flex-col mt-4 px-4" role="menubar" aria-label="Mobile Menu">
            <li className="mb-1" role="none">
              <Link 
                className="flex items-center gap-3 py-3 px-4 rounded-xl text-[#131738] font-medium text-[16px] hover:bg-[#eff6ff] hover:text-[#007bff] transition-all duration-200 no-underline" 
                to="/" 
                role="menuitem"
                onClick={() => {
                  closeMobileMenu();
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
              >
                <span className="flex items-center justify-center w-9 h-9 rounded-full bg-[#eff6ff] text-[#007bff]">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /></svg>
                </span>
                Home
              </Link>
            </li>
            
            <li className="mb-1" role="none">
              <button
                className="w-full flex items-center gap-3 py-3 px-4 rounded-xl text-[#131738] font-medium text-[16px] hover:bg-[#eff6ff] hover:text-[#007bff] transition-all duration-200 bg-transparent border-0"
                onClick={() => setShowDropdownServices(!showDropdownServices)}
                aria-expanded={showDropdownServices}
              >
                <span className="flex items-center justify-center w-9 h-9 rounded-full bg-[#eff6ff] text-[#007bff]">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" /></svg>
                </span>
                <span className="flex-1 text-left">Services</span>
                <svg className={`w-4 h-4 transition-transform duration-300 ${showDropdownServices ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              <ul className={`ml-12 mt-2 rounded-xl border border-[#e0e7ff] bg-white/80 backdrop-blur overflow-hidden transition-all duration-300 ${showDropdownServices ? 'max-h-[420px] opacity-100 py-2' : 'max-h-0 opacity-0 py-0'}`}>
                {servicesItems.map((item, index) => (
                  <li key={index} role="none">
                    <Link 
                      className="flex items-center gap-3 py-2.5 px-3 text-[#131738] text-[14px] transition-all duration-200 no-underline hover:text-[#007bff] rounded-lg hover:bg-[#eff6ff]"
                      to={item.path} 
                      role="menuitem"
                      onClick={() => {
                        closeMobileMenu();
                        setShowDropdownServices(false);
                      }}
                    >
                      <item.icon className="text-[#007bff]" aria-hidden="true" />
                      <span>{item.label}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
            
            <li className="mb-1" role="none">
              <Link 
                className="flex items-center gap-3 py-3 px-4 rounded-xl text-[#131738] font-medium text-[16px] hover:bg-[#eff6ff] hover:text-[#007bff] transition-all duration-200 no-underline" 
                to="/pricing" 
                role="menuitem"
                onClick={() => {
                  closeMobileMenu();
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
              >
                <span className="flex items-center justify-center w-9 h-9 rounded-full bg-[#eff6ff] text-[#007bff]">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                </span>
                Pricing
              </Link>
            </li>
            
            <li className="mb-1" role="none">
              <Link 
                className="flex items-center gap-3 py-3 px-4 rounded-xl text-[#131738] font-medium text-[16px] hover:bg-[#eff6ff] hover:text-[#007bff] transition-all duration-200 no-underline" 
                to="/why-bookscomply" 
                role="menuitem"
                onClick={() => {
                  closeMobileMenu();
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
              >
                <span className="flex items-center justify-center w-9 h-9 rounded-full bg-[#eff6ff] text-[#007bff]">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" /></svg>
                </span>
                Why BooksComply
              </Link>
            </li>
            
            <li className="mb-1" role="none">
              <Link 
                className="flex items-center gap-3 py-3 px-4 rounded-xl text-[#131738] font-medium text-[16px] hover:bg-[#eff6ff] hover:text-[#007bff] transition-all duration-200 no-underline" 
                to="/blog" 
                role="menuitem"
                onClick={() => {
                  closeMobileMenu();
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
              >
                <span className="flex items-center justify-center w-9 h-9 rounded-full bg-[#eff6ff] text-[#007bff]">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" /></svg>
                </span>
                Blog
              </Link>
            </li>
          </ul>

          {/* CTA Buttons */}
          <div className="flex flex-col gap-3 px-4 mt-6 pt-6 border-t border-[#e2e8f0]" role="navigation" aria-label="Account Actions">
            <button
              className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-[#ffc107] to-[#ffca2c] text-black font-semibold px-4 py-3.5 rounded-xl shadow-[0_4px_14px_rgba(255,193,7,0.4)] hover:shadow-[0_6px_20px_rgba(255,193,7,0.5)] transition-all duration-300"
              onClick={(e) => {
                handleGetStartedClick(e);
                closeMobileMenu();
              }}
              aria-label="Contact Us"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" /></svg>
              Get in Touch
            </button>
            <button
              className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-[#007bff] to-[#0056b3] text-white font-semibold px-4 py-3.5 rounded-xl shadow-[0_4px_14px_rgba(0,123,255,0.4)] hover:shadow-[0_6px_20px_rgba(0,123,255,0.5)] transition-all duration-300"
              onClick={() => {
                window.location.href = `${process.env.REACT_APP_REDIRECT_URL}/login`;
                closeMobileMenu();
              }}
              aria-label="Login to your account"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" /></svg>
              Login
            </button>
          </div>
        </div>
      </nav>

      {/* Contact Form Modal */}
      {showContactForm && (
        <ContactForm onClose={handleCloseContactForm} />
      )}
    </>
  );
};
export default NavigationBar;